import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaArrowRight,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { projects } from "../../data/projects";

const HeroFeaturedProjects = () => {
  // Use first 4 projects for the homepage
  const featuredProjects = projects.slice(0, 4);

  return (
    <section className="py-12 md:py-24 bg-slate-50">
      <div className="container-custom">

        {/* Section Header */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Featured Projects
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Building Landmarks &
            <span className="text-[#F59E0B]">
              {" "}Creating Value
            </span>
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            Explore some of our successful residential,
            commercial and development projects that
            showcase our commitment to quality and excellence.
          </p>

        </div>

        {/* Projects Grid */}

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">

          {featuredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{
                opacity: 0,
                y: 50,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-3xl shadow-lg"
            >

              {/* Image */}

              <img
                src={project.image}
                alt={project.title}
                className="h-[420px] w-full object-cover group-hover:scale-110 transition duration-700"
              />

              {/* Overlay */}

              <div className="absolute inset-0 bg-gradient-to-t from-[#082B57] via-[#082B57]/60 to-transparent" />

              {/* Content */}

              <div className="absolute bottom-0 left-0 p-6 text-white w-full">

                <span className="inline-block bg-[#F59E0B] px-4 py-1 rounded-full text-sm font-medium mb-3">
                  {project.category}
                </span>

                <h3 className="text-xl font-bold mb-3">
                  {project.title}
                </h3>

                <div className="flex items-center gap-2 text-sm text-white/80">
                  <FaMapMarkerAlt />
                  {project.location}
                </div>



              </div>

            </motion.div>
          ))}

        </div>

        {/* CTA */}

        <div className="text-center mt-14">

          <Link
            to="/projects"
            className="inline-flex items-center gap-3 bg-[#082B57] hover:bg-[#061f3d] text-white px-8 py-4 rounded-xl font-semibold transition"
          >
            View All Projects
            <FaArrowRight />
          </Link>

        </div>

      </div>
    </section>
  );
};

export default HeroFeaturedProjects;